// Opens a printable delivery / packing label in a new window and triggers print.
export function printDeliveryLabel({ orderId, customerName, customerPhone, address, items = [], vendorName }) {
  const addr = address || {};
  const addrLines = [
    addr.address_line1,
    addr.address_line2,
    [addr.city, addr.state, addr.pincode].filter(Boolean).join(", "),
  ].filter(Boolean);

  const itemsHtml = items
    .map(
      (i) =>
        `<tr><td style="padding:6px 8px;border-bottom:1px solid #e5e0d5">${
          i.product_name || i.name || ""
        }</td><td style="padding:6px 8px;border-bottom:1px solid #e5e0d5;text-align:center;width:60px">${
          i.quantity
        }</td></tr>`
    )
    .join("");

  const html = `<!doctype html><html><head><meta charset="utf-8"/>
  <title>Delivery Label ${orderId ? "#" + orderId.slice(0, 8) : ""}</title>
  <style>
    *{font-family:Arial,Helvetica,sans-serif;box-sizing:border-box}
    body{margin:0;padding:20px;color:#2A4037}
    .label{max-width:420px;border:2px solid #2A4037;border-radius:12px;padding:20px;margin:0 auto}
    .brand{font-size:22px;font-weight:800;color:#2A4037;letter-spacing:.5px}
    .tag{font-size:11px;color:#7a7364;margin-top:2px}
    h3{margin:16px 0 6px;font-size:12px;text-transform:uppercase;letter-spacing:.5px;color:#7a7364}
    .name{font-size:18px;font-weight:700}
    .row{font-size:14px;line-height:1.5}
    table{width:100%;border-collapse:collapse;margin-top:4px;font-size:14px}
    .foot{margin-top:16px;border-top:1px dashed #b8b09c;padding-top:10px;font-size:12px;color:#7a7364}
    .oid{font-size:13px;font-weight:700;background:#f3efe6;padding:4px 8px;border-radius:6px;display:inline-block}
  </style></head><body>
  <div class="label">
    <div class="brand">OrgShop</div>
    <div class="tag">Organic & Wood-pressed Oils</div>
    <div style="margin-top:12px"><span class="oid">Order #${orderId ? orderId.slice(0, 8) : "-"}</span></div>
    <h3>Ship To</h3>
    <div class="name">${customerName || "Customer"}</div>
    <div class="row">${customerPhone || ""}</div>
    <div class="row">${addrLines.join("<br/>")}</div>
    <h3>Items</h3>
    <table><tbody>${itemsHtml || '<tr><td style="padding:6px 8px">—</td><td></td></tr>'}</tbody></table>
    <div class="foot">Seller: ${vendorName || "OrgShop Vendor"}<br/>Handle with care · Keep away from heat</div>
  </div>
  <script>window.onload=function(){window.print();}</script>
  </body></html>`;

  const win = window.open("", "_blank", "width=460,height=680");
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
}
